var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "group" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-2" }, [
        _c("h3", [
          _vm._v(
            _vm._s(
              _vm.name
                ? _vm.name
                : _vm.trans("menu_planner_select.without_type")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn-set pull-right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-danger",
            attrs: { disabled: !_vm.canEdit || _vm.isRemoving },
            on: {
              click: function($event) {
                return _vm.removeType()
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.trans("menu_planner_select.remove_type")) +
                "\n      "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "table-responsive express-container" }, [
      _c(
        "table",
        {
          staticClass: "table table-bordered",
          attrs: { id: "menu-planner-table" }
        },
        [
          _c("thead", [
            _c("tr", { staticClass: "menu-header" }, [
              _c("th", [_vm._v(_vm._s(_vm.trans("menu_planner.final_meal")))]),
              _vm._v(" "),
              _c("th", [
                _vm._v(_vm._s(_vm.trans("menu_planner.final_meal_id")))
              ]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.trans("meal.entity.rate")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.trans("badge.badge")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.trans("meal.entity.tags")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.trans("meal.entity.sizes")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.trans("meal.entity.costs")))]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.trans("meal.entity.prices")))]),
              _vm._v(" "),
              _c("th", [
                _vm._v(_vm._s(_vm.trans("menu_planner_select.actions")))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.meals, function(meal, index) {
                return [
                  _c("menu-planner-select-edit-meal", {
                    key: index,
                    attrs: {
                      "available-meals": _vm.availableMeals,
                      brand: _vm.brand,
                      "can-edit": _vm.canEdit,
                      date: _vm.date,
                      "express-meal": meal,
                      "express-variant-id": _vm.expressVariantId,
                      index: index,
                      "type-id": _vm.typeId
                    },
                    on: {
                      remove: function($event) {
                        return _vm.remove(index)
                      },
                      set: _vm.set
                    }
                  })
                ]
              })
            ],
            2
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23ed413a", { render: render, staticRenderFns: staticRenderFns })
  }
}